import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import Landing from "./views/Landing.vue";
import GroupHomePage from "./views/GroupHomePage";
import CreateGroup from "./views/CreateGroup";
import CalendarPage from "./views/CalendarPage";
import ArticlePage from "./views/ArticlePage";

import MembersPage from "./views/MembersPage";

import firebase from "./firebaseConfig";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "landing",
      component: Landing,
      meta: {
        title: "Get Started | Log in"
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        title: "Dashboard",
        requiresAuth: true
      }
    },
    {
      path: "/dashboard/create",
      name: "create",
      component: CreateGroup,
      meta: {
        title: "Create",
        requiresAuth: true
      }
    },
    {
      path: "/:groupID/home",
      name: "home",
      component: GroupHomePage,
      meta: {
        title: "Homepage",
        requiresAuth: true
      }
    },
    {
      path: "/:groupID/calendar",
      name: "calendar",
      component: CalendarPage,
      meta: {
        title: "Calendar",
        requiresAuth: true
      }
    },
    {
      path: "/:groupID/posts",
      name: "posts",
      component: ArticlePage,
      meta: {
        title: "Posts",
        requiresAuth: true
      }
    },
    {
      path: "/:groupID/members",
      name: "members",
      component: MembersPage,
      meta: {
        title: "Members",
        requiresAuth: true
      }
    }
  ]
});

// Prevents navigation to certain pages if you are not logged in
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  firebase.auth().onAuthStateChanged(user => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!user) {
        next({
          path: "/landing"
        });
      } else {
        next();
      }
    } else {
      if (user && to.name === "landing") {
        next({
          path: "/dashboard"
        });
      } else {
        next();
      }
    }
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js